import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Col, Row, Form, Modal } from 'react-bootstrap'
import { ContactButton, InputWithIcon, NextBackButton, SelectionDropdown } from '../../../ui/CustomElements'
import { Box, InnerHeading, LabelStyled, LazyImage, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowRight, BackArrow, BackArrowActive, NextArrow, SuccessLogo } from '../../../ui/AllImages'
import axios from 'axios'
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next'
import { AcList, kitchenList } from '../../projectData/Data'
import ContactApi from '../../../services/api/contactApi'
import ValidatedInput from '../../inputFields/ValidatedInput'
import ValidationErrorText from '../../inputFields/ValidationErrorText'
const StepFour = ({ nextStep, prevStep, formData, setFormData }) => {
    const { t, i18n: {language} } = useTranslation();
    const [acType, setACType] = useState([]);
    const [kitchenOptions, setKitchenOptions] = useState([]);
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,
        formState: { errors },
      } = useForm({
        mode: "onBlur",
      });
    const fetchACTypeOptions = async () => {
        try {
        const response = await ContactApi.acType();
        if (response?.data) {
            reset({
                ac_type_id: response?.data?.id || "",
            });
            const mappedACTypeOptions = response.data.map(
            (type) => ({ 
                label: `${language === "ar" ? type.name_ar : type.name}`,
                value: type.id,
            }));
            setACType(mappedACTypeOptions);
        }
        } catch (error) {}
    };
    const fetchKitchenTypeOptions = async () => {
        try {
        const response = await ContactApi.kitchenTypes();
        if (response?.data) {
            reset({
                kitchen_type_id: response?.data?.id || "",
            });
            const mappedKitchenTypeOptions = response.data.map(
            (kitchenType) => ({ 
                label: `${language === "ar" ? kitchenType.name_ar : kitchenType.name}`,
                value: kitchenType.id,
            }));
            setKitchenOptions(mappedKitchenTypeOptions);
        }
        } catch (error) {}
    };
    useEffect(() => {
        fetchACTypeOptions([]);
        fetchKitchenTypeOptions({});
      }, [setACType, setKitchenOptions, language]);
    const onSubmit = (data) => {
        const haskithenType = !!data.kitchen_type_id;
        const hasCabins = !!data.no_of_cabins;
        if (hasCabins && !haskithenType) {
            return;
        }
        if (haskithenType && !hasCabins) {
            return;
        }
        setFormData((prevData) => ({ ...prevData, ...data }));
        nextStep();
    };
    useEffect(() => {
        reset(formData);
    }, [formData, reset, acType, kitchenOptions]);
    const handlePrevStep = (event) => {
        event.preventDefault();
        event.stopPropagation();
        prevStep();
    };
    return (
        <ContacFormWapper className='contactFormWrapper'>
            <Box>
                <Box className=''>
                    <Box className='d-flex flex-column align-items-start justify-content-start contactHeading'>
                        <InnerHeading className='' lh="1.2" size="20px" color="var(--themeColor)">{t('LuggageInformation')}</InnerHeading>
                    </Box>
                </Box>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className=''>
                        <Col md={12} lg={6} className='py-2 inputCol'>
                            <ValidatedInput
                                name="no_of_rooms"
                                type="input"
                                fieldType="text"
                                placeholder={t('NoofRooms')} 
                                label={t('NoofRooms')}
                                register={register}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}
                            />
                        </Col>
                        <Col md={12} lg={6} className='py-2 inputCol'>
                            <ValidatedInput
                                name="no_of_sofas"
                                type="input"
                                fieldType="text"
                                placeholder={t('NoofSofas')} 
                                label={t('NoofSofas')}
                                register={register}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}
                            />
                        </Col>
                        <Col lg={12} className='py-2 inputCol'>
                            <LabelStyled className='pt-2 pb-1'>{t('AirConditions')}</LabelStyled>
                            <SelectionDropdown
                                name="ac_type_id"
                                placeholder={t("SelectOne")}
                                options={acType}
                                value={watch("ac_type_id") || formData?.ac_type_id}
                                register={register}
                                errors={errors}
                                validationRules={{
                                    required: watch("no_of_split_acs") || watch("no_of_window_acs") ? true : false,
                                }}
                            />
                            {errors.ac_type_id && (
                                <ValidationErrorText text={t("Please select an AC type")} />
                            )}
                        </Col>
                        <Col md={12} lg={6} className='py-2 inputCol'>
                            <ValidatedInput
                                name="no_of_split_acs"
                                type="input"
                                fieldType="text"
                                className="errorACUnit"
                                placeholder={t('NoofSplitACs')} 
                                label={t('NoofSplitACs')}
                                register={register}
                                errors={errors}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}
                                validationRules={{
                                    validate: (value) => {
                                      if (watch("ac_type_id") && !value && !watch("no_of_window_acs")) {
                                        return t("enterleastSplitWindow");
                                      }
                                      return true;
                                    },
                                }}
                                />
                        </Col>
                        <Col md={12} lg={6} className='py-2 inputCol'>
                            <ValidatedInput
                                name="no_of_window_acs"
                                type="input"
                                fieldType="text"
                                placeholder={t('NoofWindowACs')} 
                                label={t('NoofWindowACs')}
                                register={register}
                                errors={errors}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}
                                validationRules={{
                                    validate: (value) => {
                                      if (watch("ac_type_id") && !value && !watch("no_of_split_acs")) {
                                        return "";
                                      }
                                      return true;
                                    },
                                }}
                                />
                        </Col>
                        <Col md={12} lg={6} className='py-2 inputCol'>
                            <LabelStyled className='pt-2 pb-1'>{t('Kitchen')}</LabelStyled>
                            <SelectionDropdown
                                name="kitchen_type_id"
                                placeholder={t("SelectOne")}
                                options={kitchenOptions}
                                value={watch("kitchen_type_id") || formData?.kitchen_type_id}
                                register={register}
                                errors={errors}
                                validationRules={{
                                    required: watch("no_of_cabins") ? true : false,
                                }}
                            />
                            {errors.kitchen_type_id?.type === "required" && (
                                <ValidationErrorText
                                    text={
                                        t(errors.kitchen_type_id?.message) ||
                                        t("Pleaseselectone")
                                    }
                                />
                            )}
                        </Col>
                        <Col md={12} lg={6} className='py-2 inputCol'>
                            <ValidatedInput
                                name="no_of_cabins"
                                type="input"
                                fieldType="text"
                                placeholder={t('NoofCabins')} 
                                label={t('NoofCabins')}
                                register={register}
                                errors={errors}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                }}
                                validationRules={{
                                    required: watch("kitchen_type_id") ? true : false,
                                  }}
                            />
                        </Col>
                        <Box className='d-flex justify-content-between w-100 mt-5 btnNBWrap'>
                            <NextBackButton type="button" className="" content='end' backIcon={BackArrowActive} label={t('back')} bg="var(--white)" onClick={handlePrevStep}/>
                            <Box className="nextTextContainer">
                                <Box className='progressTextContainer'>
                                    <SpanStyled className='txtEng'>
                                        4
                                    </SpanStyled>
                                    <SpanStyled className='ofProgTxt'>
                                        {t("Of")}
                                    </SpanStyled>
                                    <SpanStyled className='txtEng'>
                                        5
                                    </SpanStyled>
                                </Box>
                                <NextBackButton type="submit" className="" nextIcon={NextArrow} label={t('next')} />
                            </Box>
                        </Box>
                    </Row>
                </Form>
            </Box>
        </ContacFormWapper >
    )
}
const ContacFormWapper = styled.div`
`
export default StepFour
